import { Component, input } from '@angular/core';

import { StockAmount } from '../../types/stock-amount';

@Component({
  selector: 'soft-stock-amount',
  imports: [],
  templateUrl: './stock-amount.component.html',
  styleUrl: './stock-amount.component.css',
})
export class StockAmountComponent {
  stockAmount = input.required<StockAmount>()
}
